const video = document.querySelector('.MainHeader-video');

if (video) {
  video.play();
}
